import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import DeductInventory from './component';

import style from '../style.module.less';

const deductInventory = {
  id: 'markAsShipped.columns.deductInventory',
  defaultMessage: 'Deduct Inventory',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(deductInventory);
};

export default {
  id: 'mark-as-shipped-deduct-inventory',
  index: 2,
  isDragable: false,
  minWidth: 100,
  width: 100,
  nonsortable: true,
  getName: GetName,
  name: (
    <div className={style['long-column-header']}>
      <FormattedMessage {...deductInventory} />
    </div>
  ),
  render: (data) => {
    return <DeductInventory fulfillmentPlanId={data.id} />;
  },
};
